import { BaseDto } from '@/core';

export class GraphSelectionDto extends BaseDto<GraphSelectionDto> {
  spaceCity?: string;
}
